var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.15 15.11a5.46 5.46 0 0 0-3.7.13C.77 15.89.34 17.1.56 18a2.7 2.7 0 0 0-.18 1.44c.35 2.71 4.28 3.17 6.34 1.68a2.61 2.61 0 0 0 .87-2.93 2.35 2.35 0 0 0-1.44-3.08ZM2.71 16a4.45 4.45 0 0 1 3 .11 1.47 1.47 0 0 1 .95 1.2c.05 1.4-2.42 2.23-4.3 1.47-1.55-.64-1.64-2.21.35-2.78Zm3.49 4.31C5 21 1.27 21.43 1.11 18.92a4.73 4.73 0 0 0 5.89.13 1.49 1.49 0 0 1-.8 1.26Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.51 11.71c-2.07-.79-6.2.28-5.65 2.43a2.25 2.25 0 0 0 .33 2.53c1.81 2 7.19 2 6.68-2.17.51-.94.13-2.15-1.36-2.79Zm-3.4.79a5.22 5.22 0 0 1 3 .21c2.39 1.08-.55 3-3.37 2.07-1.69-.54-1.74-1.85.37-2.28Zm3.08 4.05c-1.34.61-4.8.31-4.81-1.6a5.28 5.28 0 0 0 5.81.32 1.56 1.56 0 0 1-1 1.28Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.66 20c.35-1-.2-2.15-1.78-2.53-2.14-.44-6.08 1.26-5.2 3.31a2.26 2.26 0 0 0 .73 2.45 4.74 4.74 0 0 0 4.2.57 2.83 2.83 0 0 0 2.05-3.8Zm-5-1.2a5.23 5.23 0 0 1 3-.28c2.53.68-.08 3-3 2.6-1.88-.32-1.87-1.65-.01-2.36Zm3.67 3.49c-1.29.87-4.7 1.05-5-.79a5.31 5.31 0 0 0 5.79-.63 1.58 1.58 0 0 1-.8 1.38Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0c-1-.17-4.06 1.6-4.08 1.68-.3 1 2.36-.12 3.12-.38-1.84 3-2.91 4.07-3.09 4.53s-1.05-.72-1.28-.83c-2.27-1.59-2.83-.81-4.46 1.7a.3.3 0 0 0 .49.34 11.39 11.39 0 0 1 1.67-1.8c.62-.53 1.81 1 2.93 1.6a1 1 0 0 0 1.22-.07c.94-.83 2.55-3.9 3.1-5L23 3.81a.34.34 0 1 0 .67 0C23.8 1.22 24 .19 23.16 0Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45 13.38a3.24 3.24 0 0 1-.36-1.32 7.55 7.55 0 0 1 2.05-4.44c1.32-1.39 1.52-.73 2-1.11a.3.3 0 0 0 0-.42c-.27-.38-1-.11-1.42.07C1 7.3-.88 11.23.88 13.73a.33.33 0 1 0 .57-.35Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 6.24a5 5 0 0 1 3.94 5.3 6 6 0 0 1-1.27 3.28c-.3.25.09.7.39.45a6.69 6.69 0 0 0 1.91-3.54c.69-3-1.89-5.89-4.89-6.16a.34.34 0 0 0-.08.67Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66 4.85c.66.71.84.91 1 .94A.28.28 0 0 0 5 5.71c.34-.37-2.36-2.65-1.46-3.22a1 1 0 0 1 1.21.24c.51.6.55.68.67.75a.69.69 0 0 0 .84-.17c.27-.28.3-.6.89-1 .2-.15.61-.37.77-.18.33.4.07.84.29 1.18a.49.49 0 0 0 .65.2 3.25 3.25 0 0 0 .44-.34c.08-.06.31-.1.43-.19A4 4 0 0 1 9.1 4.8a.34.34 0 0 0 .6.32 7 7 0 0 0 .71-1.59 2.09 2.09 0 0 0 .06-.95c-.09-.52-.55-.85-1.45-.4C8.72.69 7.14.34 5.71 2.05c-.08.1 0 .2-.28-.16a2 2 0 0 0-2.5-.19c-1.16.9-.25 2.1.73 3.15Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94 10.42c-.4-.14-.72-.16-1.4-.39-.16-.21.48-.91.8-.9l.88.35a.3.3 0 0 0 .11-.59c-.27-.07-.3-.3-.79-.45a1.11 1.11 0 0 0-.42-1.39c-.23 0-.8.7-.44 1.48-1.34.58-1.84 2.14-.19 2.68a6.45 6.45 0 0 1 1.78.6c.08 0-.13.14-.24.18a4.36 4.36 0 0 1-1.65.24.34.34 0 0 0-.09.67 4 4 0 0 0 .8.07c-.17.57.35 1.38.65 1.34s.62-1.06.24-1.42l.32 0c1.26-.36 1.45-1.84-.36-2.47Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.e70931fefba17402e1df139fd8285854.svg";
export { ForwardRef as ReactComponent };